'use strict'

import $ from 'jquery'

export default class ResourcesFilter {
    constructor(el) {
        this.$el = $(el)
        this.$cards = this.$el.find('.card')
        this.$count = this.$el.find('.post-listing__count')
        this.$topicFilterGroup = this.$el.find('.post-listing__filter-group-topic')
        this.$topicFilter = this.$el.find('.post-listing__filter-topic')
        this.$languageFilterGroup = this.$el.find('.post-listing__filter-group-language')
        this.$languageFilter = this.$el.find('.post-listing__filter-language')
        this.$grid = this.$el.find('.post-listing__grid')
        this.$loadMore = this.$el.find('.post-listing__load-more')

        //Abort if no filtering mechanism
        if (!this.$topicFilter.length) return false

        //State
        this.activeFilter = 'All'
        this.cardSets = {}
        this.setLength = 12
        this.setsLoaded = 1
        this.masterFilter = {}
        this.activeFilterSet = { topicType: [], resourceType: [], languageType: [] }

        //Init
        this.cleanFilters()
        this.organizeTopicSets()
        this.bindEvents()

        const urlParams = new URLSearchParams(window.location.search);
        // const myParam = urlParams.get('myParam');
        if (urlParams.get('resource-type')) {
            this.$topicFilter.find('li').each((index, filter) => {
                if ($(filter).data('filter') === urlParams.get('resource-type')) {
                    this.handleFilterUpdate($(filter));
                }
            });
        }

        this.handleCardLoading()

    }
    bindEvents() {
        this.$topicFilter.find('li').on('click', (e) => {
            this.handleFilterUpdate($(e.currentTarget))
            this.handleCardLoading()
        })
        this.$topicFilterGroup.find('p').on('click', (e) => {
            $(e.currentTarget).parent(this.$topicFilterGroup).toggleClass('menu-open')
        })

        this.$languageFilter.find('li').on('click', (e) => {
            this.handleFilterUpdate($(e.currentTarget))
            this.handleCardLoading()
        })
        this.$languageFilterGroup.find('p').on('click', (e) => {
            $(e.currentTarget).parent(this.$languageFilterGroup).toggleClass('menu-open')
        })

        // Currently disabled on line 21 - leaving for future availability
        this.$loadMore.on('click', (e) => {

            this.setsLoaded++
            e.preventDefault()
            this.handleCardLoading()
        })
    }
    cleanFilters() {
        //If a topic category is empty, remove its filter option
        this.$topicFilter.find($('[data-filter]').each((i, v) => {
            const cardsExistForThisTopic = this.$el.find(`[data-resource-type="${$(v).data('filter')}"]`).length
            const cardsExistForThisType = this.$el.find(`[data-topic-type="${$(v).data('filter')}"]`).length
            const cardsExistForThisLanguage = this.$el.find(`[data-language="${$(v).data('filter')}"]`).length
            const isNotAllTopic = $(v).data('filter') === 'All'
            // Commented out to show dropdown options
            // if (!cardsExistForThisTopic && !isNotAllTopic) $(v).hide()
        }))
    }
    handleFilterUpdate($filter) {
        const filterCategory = $filter.parent().data('category')
        const newTopic = $filter.data('filter')
        const newTopicAll = $filter.data('filter-name')

        if (!$filter.hasClass('active')) {
            // Check if click target is inactive
            if (newTopic === 'All') {
                // Check if click is targeting "All", if so, add all posts to dropdowns available array of posts
                this.activeFilterSet[filterCategory] = this.masterFilter[filterCategory]
                // Update dropdown label to reflect current selection
                $filter.parent('.post-listing__filter').siblings('p').html(newTopicAll)

                window.history.pushState(null, "", this.$el.data('base'));
            } else {
                // If not "All", purge active array of contents
                this.activeFilterSet[filterCategory] = []
                // Then push latest tag selection into active array
                this.activeFilterSet[filterCategory].push(newTopic)
                // Update dropdown label to reflect current selection
                $filter.parent('.post-listing__filter').siblings('p').html($filter.text())
                window.history.pushState(null, "", this.$el.data('base') + '?resource-type=' + newTopic);

            }
            // Remove active status from previously active selection
            $filter.siblings().removeClass('active')
            // Add active status to latest selection
            $filter.addClass('active')
        }
        // Collapse open filter dropdown
        $filter.closest('.post-listing__filter-group').removeClass('menu-open')
        //Reset how many sets of cards should be shown
        this.setsLoaded = 1
    }
    filterCards() {
        const $topicFilteredCards = []
        const { resourceType, topicType, languageType } = this.activeFilterSet
        this.$cards.each((i, card) => {
            if (
                resourceType.includes($(card).data('resource-type')) &&
                topicType.includes($(card).data('topic-type')) &&
                languageType.includes($(card).data('language'))
            ) {
                $topicFilteredCards.push($(card))
            }
        })
        return $topicFilteredCards
    }
    handleCardLoading() {
        const $cardsToLoad = this.filterCards()
        const numberToLoad = this.setsLoaded * this.setLength

        //Empty grid and append the right amount of topics to show
        this.$grid.empty()
        for (let i = 0; i < numberToLoad; i++) {
            if ($cardsToLoad[i]) this.$grid.append($cardsToLoad[i])
        }

        // If there aren't more cards to show, hide the Load More button
        $cardsToLoad.length >= numberToLoad ? this.$loadMore.show() : this.$loadMore.hide()

        //Update the count values
        this.updateCountValues()
    }
    organizeTopicSets() {
        //Build array of every category and create a unique set
        const topicNameDump = []
        const topicTypeNameDump = []
        const languageNameDump = []
        this.$cards.each((i, v) => topicNameDump.push($(v).data('resource-type')))
        this.$cards.each((i, v) => topicTypeNameDump.push($(v).data('topic-type')))
        this.$cards.each((i, v) => languageNameDump.push($(v).data('language')))
        const uniqueTopics = [...new Set(topicNameDump)]
        const uniqueTopicTypes = [...new Set(topicTypeNameDump)]
        const uniqueLanguage = [...new Set(languageNameDump)]

        this.masterFilter = { resourceType: uniqueTopics, topicType: uniqueTopicTypes, languageType: uniqueLanguage }
        this.activeFilterSet = { resourceType: uniqueTopics, topicType: uniqueTopicTypes, languageType: uniqueLanguage }

        //Build categorized object of topics keys, each with an array of their corresponding cards
        uniqueTopics.forEach(v => this.cardSets[v] = [])
        uniqueTopicTypes.forEach(v => this.cardSets[v] = [])
        uniqueLanguage.forEach(v => this.cardSets[v] = [])
        this.$cards.each((i, v) => {
            const topic = $(v).data('resource-type')
            const topicType = $(v).data('topic-type')
            const language = $(v).data('language')
            this.cardSets[topic].push($(v))
            this.cardSets[topicType].push($(v))
            this.cardSets[language].push($(v))
        })
    }
    updateCountValues() {
        const visible = this.$grid.find('.card').length
        const total = this.activeFilter === 'All' ?
            this.$cards.length :
            this.cardSets[this.activeFilter].length

        this.$count.find('span').eq(0).text(visible)
        this.$count.find('span').eq(1).text(total)
    }

}
